// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetIndexAdvisorDatabaseQueryVariables = Types.Exact<{
  databaseId: Types.Scalars["ID"]["input"];
}>;

export type GetIndexAdvisorDatabaseQuery = {
  __typename?: "GraphqlQuery";
  getDatabaseDetails: {
    __typename?: "Database";
    id: string;
    isNodeInCluster: boolean;
    clusterPrimaryDatabaseId: string;
  };
};

export const GetIndexAdvisorDatabaseDocument = gql`
  query GetIndexAdvisorDatabase($databaseId: ID!) {
    getDatabaseDetails(databaseId: $databaseId) {
      id
      isNodeInCluster
      clusterPrimaryDatabaseId
    }
  }
`;

/**
 * __useGetIndexAdvisorDatabaseQuery__
 *
 * To run a query within a React component, call `useGetIndexAdvisorDatabaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIndexAdvisorDatabaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIndexAdvisorDatabaseQuery({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *   },
 * });
 */
export function useGetIndexAdvisorDatabaseQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetIndexAdvisorDatabaseQuery,
    GetIndexAdvisorDatabaseQueryVariables
  > &
    (
      | { variables: GetIndexAdvisorDatabaseQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetIndexAdvisorDatabaseQuery,
    GetIndexAdvisorDatabaseQueryVariables
  >(GetIndexAdvisorDatabaseDocument, options);
}
export function useGetIndexAdvisorDatabaseLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetIndexAdvisorDatabaseQuery,
    GetIndexAdvisorDatabaseQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetIndexAdvisorDatabaseQuery,
    GetIndexAdvisorDatabaseQueryVariables
  >(GetIndexAdvisorDatabaseDocument, options);
}
// @ts-ignore
export function useGetIndexAdvisorDatabaseSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetIndexAdvisorDatabaseQuery,
    GetIndexAdvisorDatabaseQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetIndexAdvisorDatabaseQuery,
  GetIndexAdvisorDatabaseQueryVariables
>;
export function useGetIndexAdvisorDatabaseSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetIndexAdvisorDatabaseQuery,
        GetIndexAdvisorDatabaseQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetIndexAdvisorDatabaseQuery | undefined,
  GetIndexAdvisorDatabaseQueryVariables
>;
export function useGetIndexAdvisorDatabaseSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetIndexAdvisorDatabaseQuery,
        GetIndexAdvisorDatabaseQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetIndexAdvisorDatabaseQuery,
    GetIndexAdvisorDatabaseQueryVariables
  >(GetIndexAdvisorDatabaseDocument, options);
}
export type GetIndexAdvisorDatabaseQueryHookResult = ReturnType<
  typeof useGetIndexAdvisorDatabaseQuery
>;
export type GetIndexAdvisorDatabaseLazyQueryHookResult = ReturnType<
  typeof useGetIndexAdvisorDatabaseLazyQuery
>;
export type GetIndexAdvisorDatabaseSuspenseQueryHookResult = ReturnType<
  typeof useGetIndexAdvisorDatabaseSuspenseQuery
>;
export type GetIndexAdvisorDatabaseQueryResult = Apollo.QueryResult<
  GetIndexAdvisorDatabaseQuery,
  GetIndexAdvisorDatabaseQueryVariables
>;
